import InsideSalesAttachments from './InsideSalesAttachments';

export default InsideSalesAttachments;
